var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "log-in"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6785 10.4638C9.43442 10.7079 9.43442 11.1036 9.6785 11.3477L12.1785 13.8477C12.4226 14.0918 12.8183 14.0918 13.0624 13.8477C13.3065 13.6036 13.3065 13.2079 13.0624 12.9638L11.6293 11.5308H15.9538C16.299 11.5308 16.5788 11.2509 16.5788 10.9058C16.5788 10.5606 16.299 10.2808 15.9538 10.2808H11.6293L13.0624 8.8477C13.3065 8.60363 13.3065 8.2079 13.0624 7.96382C12.8183 7.71974 12.4226 7.71974 12.1785 7.96382L9.6785 10.4638Z",
    fill: "#AFAEBA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.95378 4.03076C5.37848 4.03076 4.91211 4.49713 4.91211 5.07243V16.7391C4.91211 17.3144 5.37848 17.7808 5.95378 17.7808H14.2871C14.8624 17.7808 15.3288 17.3144 15.3288 16.7391V15.9058C15.3288 15.5606 15.6086 15.2808 15.9538 15.2808C16.299 15.2808 16.5788 15.5606 16.5788 15.9058V16.7391C16.5788 18.0047 15.5528 19.0308 14.2871 19.0308H5.95378C4.68812 19.0308 3.66211 18.0047 3.66211 16.7391V5.07243C3.66211 3.80678 4.68812 2.78076 5.95378 2.78076H14.2871C15.5528 2.78076 16.5788 3.80678 16.5788 5.07243V5.90576C16.5788 6.25094 16.299 6.53076 15.9538 6.53076C15.6086 6.53076 15.3288 6.25094 15.3288 5.90576V5.07243C15.3288 4.49713 14.8624 4.03076 14.2871 4.03076H5.95378Z",
    fill: "#AFAEBA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogIn);
export default __webpack_public_path__ + "static/media/log-in.2733756e6ab1c3334c812a122a1be3d9.svg";
export { ForwardRef as ReactComponent };